<template>
  <v-app id="app">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item v-if="curUser && ((item.roles.indexOf(curUser.user_type) > -1) || (item.roles.indexOf('All') > -1))"
          v-for="item in menuItems"
          :key="item.title"
          :to="{ path: item.path, query: item.qery }"
        >
        
          <v-list-item-icon>
            <v-icon v-text="item.icon" :color="item.color"></v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>

        </v-list-item>
       
        </v-list>
        <v-divider></v-divider>
        <span class="hidden-md-and-up">
          <v-btn
            v-if="curUser && curUser.user_type == 'Admin'"
            text
            to="/signup"
          >
            <v-icon left dark>face</v-icon>
            Create User
          </v-btn>
          <v-btn v-if="!curUser" text to="/signin">
            <v-icon left dark>lock_open</v-icon>
            Sign In
          </v-btn>
          <v-btn v-if="curUser" text @click="logout">
            <v-icon left dark>eject</v-icon>
            Log Out
          </v-btn>
        </span>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="light-blue darken-4" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text"
        >SSTS (Sealdah Suburban Tracking System)</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <span class="hidden-sm-and-down">
        <v-btn
          v-if="curUser && curUser.user_type == 'Admin'"
          text
          to="/trainswithrake"
        >
          <v-badge
            :content="unattached_trains"
            :value="unattached_trains"
            color="red"
            overlap
          >
            <v-icon medium> mdi-tram </v-icon>
          </v-badge>
          Unattached Trains
        </v-btn>
        <v-btn
          v-if="curUser && curUser.user_type == 'Admin'"
          text
          to="/trainsreport"
        >
          <v-badge
            :content="unarrived_trains"
            :value="unarrived_trains"
            color="orange"
            overlap
          >
            <v-icon medium> mdi-clock-alert </v-icon>
          </v-badge>
          Not Arrived Trains
        </v-btn>
        <!-- <v-btn v-if="curUser && (curUser.user_type == 'Admin' || curUser.user_type == 'User')" text to="/trainsreport">
        <v-icon color="blue darken-2">fas fa-bell</v-icon>
        Punctality : {{this.summ["Puntuality"]}} %
      </v-btn> -->
        <span v-if="curUser" class="body-2">
          {{ curUser.username }}
        </span>
        <v-btn v-if="curUser && curUser.user_type == 'Admin'" text to="/signup">
          <v-icon left dark>face</v-icon>
          Create User
        </v-btn>
        <v-btn v-if="!curUser" text to="/signin">
          <v-icon left dark>lock_open</v-icon>
          Sign In
        </v-btn>
        <v-btn v-if="curUser" text @click="logout">
          <v-icon left dark>eject</v-icon>
          Log Out
        </v-btn>
      </span>
    </v-app-bar>

    <v-content>
      <v-container class="fill-height" fluid>
        <router-view />
      </v-container>
    </v-content>

    <v-footer dense app color="light-blue darken-4" dark>
      <v-row>
        <v-col>
          <span class="white--text"
            >&copy; Electric Operation, Sealdah, ER 2019</span
          >
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { mapState, mapGetter, mapActions } from "vuex";

export default {
  props: {
    source: String,
  },
  data: () => ({
    unattached_trains: 0,
    unarrived_trains: 0,
    alert_sound: require("./assets/sound_the_alarm.mp3"),
    drawer: null,
    menuItems: [
      {
        title: "Home",
        path: "/",
        icon: "mdi-home-variant",
        color: "light-blue accent-4",
        roles: ["All"],
      },
      {
        title: "Dashboard",
        path: "/Dashboard",
        icon: "mdi-view-dashboard",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: "Live View",
        path: "/Simple",
        icon: "mdi-map-marker-path",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Live View(L)",
        path: "/live_view_l",
        icon: "mdi-map-marker-path",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      // {
      //   title: 'Live View(S)',
      //   path: '/live_view_split',
      //   icon: 'mdi-map-marker-path',
      //   color: "light-blue accent-4",
      //   roles: ['Admin', 'TLC', 'DTNL', 'Guest']
      // },
      {
        title: 'Replay',
        path: '/SimpleReplay',
        icon: 'mdi-map-marker-path',
        color: "light-blue accent-4",
        roles: ['Admin', 'TLC', 'DTNL', 'Guest']
      },
      {
        title: "Live Station",
        path: "/livestation",
        icon: "mdi-tram",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Hog Nominated Trains",
        path: "/hog_trains",
        icon: "mdi-tram",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest","HOG"],
      },
      {
        title: "Hog Report Summary",
        path: "/hog_report_sum",
        icon: "mdi-tram",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest","HOG"],
      },
      {
        title: "Hog Report",
        path: "/hog_report",
        icon: "mdi-tram",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest","HOG"],
      },
      {
        title: "Trains Running Late",
        path: "/latetrains",
        icon: "mdi-clock-alert",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Trains on Run",
        path: "/runningtrains",
        icon: "mdi-clock-alert",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: 'PF Enter Speed',
        path: '/pf_enter_high',
        icon: 'mdi-clock-alert',
        color: "light-blue accent-4",
        roles: ['Admin']
      },
      {
        title: 'Arrivals(North)',
        path: '/desttrains/north',
        icon: ' mdi-calendar-clock',
        color: "light-blue accent-4",
        roles: ['Admin', 'TLC', 'DTNL']
      },
      {
        title: 'Arrivals(South)',
        path: '/desttrains/south',
        icon: ' mdi-calendar-clock',
        color: "light-blue accent-4",
        roles: ['Admin', 'TLC', 'DTNL']
      },
      {
        title: "Draw Geofence",
        path: "/DrawGeofenceOnMap",
        icon: "mdi-map-marker-radius",
        color: "light-blue accent-4",
        roles: ["Admin"],
      },
      {
        title: "Draw Cautions",
        path: "/DrawCautionOnMap",
        icon: "mdi-map-marker-radius",
        color: "light-blue accent-4",
        roles: ["Admin"],
      },
      {
        title: "Upload Cautions",
        path: "/cautions",
        icon: "mdi-map-marker-radius",
        color: "light-blue accent-4",
        roles: ["Admin", 'TLC', 'DTNL'],
      },
      {
        title: "Rakes",
        path: "/devices",
        icon: "train",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      // {
      //   title: 'Trackers on PF',
      //   path: '/devices_on_pf',
      //   icon: 'train',
      //   color: "light-blue accent-4",
      //   roles: ['Admin']
      // },
      {
        title: "Notifications",
        path: "/messages",
        icon: "fas fa-bell",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: "Chart Analysis",
        path: "/speedcharthigh_multiple",
        icon: "train",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Goods Analysis",
        path: "/goodsanalysis",
        icon: "train",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Punctuality analysis",
        path: "/trainsreport",
        query: {},
        icon: " mdi-chart-bar",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Hourly Punctuality analysis",
        path: "/hourly_analysis",
        icon: " mdi-chart-bar",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Section wise analysis",
        path: "/section_wise_analysis",
        icon: " mdi-chart-bar",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Crew wise analysis",
        path: "/crew_wise_analysis",
        icon: " mdi-chart-bar",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Train wise analysis",
        path: "/train_wise_analysis",
        icon: " mdi-chart-bar",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      {
        title: "Rake wise analysis",
        path: "/rake_wise_analysis",
        icon: " mdi-chart-bar",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL", "Guest"],
      },
      // {
      //   title: 'Constraint',
      //   path: '/constraint',
      //   icon: 'mdi-image-filter-hdr',
      //   color: "light-blue accent-4",
      //   roles: ['Admin', 'TLC', 'DTNL']
      // },
      {
        title: "Train Master",
        path: "/train_master",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      // {
      //   title: 'Train Master(t)',
      //   path: '/trainstab',
      //   icon: 'mdi-image-filter-hdr',
      //   color: "light-blue accent-4",
      //   roles: ['Admin', 'TLC', 'DTNL']
      // },
      {
        title: "Rake Link",
        path: "/rakelinkdtl",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: "Rake Changement",
        path: "/rake_changement",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: "Unattached Trains",
        path: "/trainswithrake",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: "Attachment Report",
        path: "/attachment_report",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      // {
      //   title: 'Rake Link Table',
      //   path: '/rake_changement1',
      //   icon: 'mdi-image-filter-hdr',
      //   color: "light-blue accent-4",
      //   roles: ['Admin', 'TLC', 'DTNL']
      // },
      {
        title: "Platform Position",
        path: "/platformpos",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: "Platform Rakes",
        path: "/platformdtl",
        icon: "mdi-image-filter-hdr",
        color: "light-blue accent-4",
        roles: ["Admin", "TLC", "DTNL"],
      },
      {
        title: 'Auto Attachment Report',
        path: '/auto_attach_rep',
        icon: 'mdi-image-filter-hdr',
        color: "light-blue accent-4",
        roles: ['Admin', 'TLC', 'DTNL']
      },
      {
        title: 'Auto Attachment Log',
        path: '/auto_attach_log',
        icon: 'mdi-image-filter-hdr',
        color: "light-blue accent-4",
        roles: ['Admin', 'TLC', 'DTNL']
      },

      {
        title: "About",
        path: "/about",
        icon: "mdi-information",
        color: "light-blue accent-4",
        roles: ["All"],
      },
    ],
    cur_date: moment().format("YYYY-MM-DD"),
    summ: {},
  }),
  computed: {
    ...mapState(["curUser", "summary"]),
  },
  created() {
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");
    axios
      .get(`${process.env.VUE_APP_API_URL}/auth/verifyjwt`)
      .then((response) => {
        this.updateCurUser(response.data);
      })
      .catch((e) => {
        console.log(e);
        if (e.response.status === 401) {
          this.$router.push({
            name: "Home",
          });
        }
      });
    setInterval(() => {
      var that = this;
      var p = {
        train_date: this.cur_date,
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(`${process.env.VUE_APP_API_URL}/train/tr/attachment_summary`, {
          params: p,
        })
        .then((response) => {
          _.assign(that.summary, response.data[0]);
          _.assign(that.summary, response.data[1]);
          that.unattached_trains =
            (that.summary.no_of_train || 0) -
            ((that.summary.after_dep_time || 0) +
              (that.summary.before_dep_time || 0));
          // require('../assets/signal_n.png')
          // const sound = ( new Audio( that.alert_sound )).play()
          // console.log(that.summary);
        })
        .catch((e) => {
          console.log(e);
        });
      axios
        .get(`${process.env.VUE_APP_API_URL}/train/tr/unarrived_trains`, {
          params: p,
        })
        .then((response) => {
          _.assign(that.summary, response.data[0]);
          that.unarrived_trains = that.summary.unarrived_trains;
          // console.log(that.summary);
        })
        .catch((e) => {
          console.log(e);
        });
    }, 60000);
  },
  mounted() {},
  methods: {
    ...mapActions(["updateCurUser", "updateSummary"]),
    showRoute(roles) {
      if (roles[0] === "All") {
        return true;
      }
      if (this.curUser && roles.indexOf(this.curUser.user_type) >= 0) {
        return true;
      }
      return false;
    },
    logout() {
      localStorage.removeItem("jwtToken");
      this.updateCurUser(null);
      this.$router.push({
        name: "Signin",
      });
    },
    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60;
        switch (true) {
          case x < 1:
            return "green";
            break;
          case x < 5:
            return "#6B8E23";
            break;
          case x < 11:
            return "blue";
            break;
          case x < 21:
            return "orange";
            break;
          case x < 31:
            return "#FF1493";
            break;
          case x < 1000:
            return "red";
            break;
          default:
            return "#F5DEB3";
            break;
        }
      }
    },
    getSummaryColour(s) {
      return s == "more than 30"
        ? "red"
        : s == "21 to 30"
        ? "#FF1493"
        : s == "11 to 20"
        ? "orange"
        : s == "5 to 10"
        ? "blue"
        : s == "less than 5"
        ? "#6B8E23"
        : s == "Right Time"
        ? "green"
        : s == "total late"
        ? "#A52A2A"
        : s == "total train"
        ? "#D2691E"
        : s == "Puctuality"
        ? "#8A2BE2"
        : "#F5DEB3";
    },
    getSummary(trains) {
      let summary = {
        "Right Time": 0,
        "less than 5": 0,
        "5 to 10": 0,
        "11 to 20": 0,
        "21 to 30": 0,
        "more than 30": 0,
        "total late": 0,
        "total train": 0,
        Puctuality: 0,
      };
      _.forEach(trains, (train) => {
        if (train.act_arr) {
          let x = train.late_arr / 60;
          switch (true) {
            case x < 1:
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case x < 5:
              summary["less than 5"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case x < 11:
              summary["5 to 10"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case x < 21:
              summary["11 to 20"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case x < 31:
              summary["21 to 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case x < 1000:
              summary["more than 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            default:
              break;
          }
        }
      });
      summary["Puctuality"] = Math.round(
        (summary["Right Time"] / summary["total train"]) * 100,
        2
      );
      return summary;
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
